import React from 'react';
import background from '../../assets/herring.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoOverfishing extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Overfishing"
        paragraph="Unsustainable fishing has led to the depletion of key species, and destabilized the food web. Such losses ripple through ecosystems and the local economies that depend on them (NOAA)."
        background={background}
     />
  
  );
 }
}   

export default InfoOverfishing;